import { jwtDecode } from 'jwt-decode';
import { LOCAL_STORAGE_TOKEN } from "../shared/http/auth";

const isTokenExpired = () => {
  const token = window.localStorage.getItem(LOCAL_STORAGE_TOKEN);
  
  if (!token) return true;

  try {
    const { exp } = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return exp < currentTime;
  } catch (e) {
    return true;
  }
};

export { isTokenExpired }